import {ResponsiveLayout} from '@frontend/components/ResponsiveLayout'
import {useTopMenuStore} from '@frontend/stores'
import {Collapse} from 'swayok-react-mdb-ui-kit/components/Collapse/Collapse'
import {TopNavigationDesktop} from './TopNavigationDesktop'
import {TopNavigationMobile} from './TopNavigationMobile'

// Верхнее меню навигации.
export function TopNavigation() {

    const show = useTopMenuStore(
        state => state.visible
    )

    return (
        <Collapse
            show={show}
            showImmediately
            tag="div"
            id="top-nav"
        >
            <ResponsiveLayout
                desktop={<TopNavigationDesktop />}
                wideTablet={<TopNavigationDesktop />}
                tablet={<TopNavigationMobile />}
                mobile={<TopNavigationMobile />}
            />
        </Collapse>
    )
}
